export const carousel = () => {
  const carousels = document.querySelectorAll('.wp-block-gallery.is-style-hero');

  if (!carousels.length) return;
};
